<template lang="pug">
	.audio-tracker-wapi-plugin-popup--number-edit
		.hoverable.clickable.text(@click="show", :style="{ '--color': (def !== value ? color : (defColor || '#999')) || 'inherit', '--font-size': `${fontSize || 10}px` }") {{value >= 0 && showSign ? '+' : ''}}{{formatNumber(value, precision || 0.1)}}{{unit || ''}}
		Popup(v-if="popupVisible", :popupVisible.sync="popupVisible", classes="tracker-dark", :width="280", :autosize="true", :title="title")
			.flex-col.space
				DxNumberBox(:value="value", @value-changed="onValueChanged", stylingMode="filled", :showSpinButtons="true", :min="min", :max="max")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="popupVisible = false")
</template>

<script>
	import Popup from 'app-core/Popup.vue';
	import DxButton from 'devextreme-vue/button';
	import DxNumberBox from 'devextreme-vue/number-box';

	export default {
		translationCategory: 'audioTracker.AudioTracker',
		name: 'audio-tracker-wapi-plugin--popup-number-edit',
		components: { Popup, DxButton, DxNumberBox },
		props: ['value', 'title', 'precision', 'unit', 'color', 'fontSize', 'min', 'max', 'showSign', 'def', 'defColor'],
		data() {
			return {
				popupVisible: false
			}
		},
		watch: {
		},
		mounted() {
		},
		methods: {
			show() {
				this.popupVisible = false;
				this.$nextTick(() => {
					this.popupVisible = true;
				})
			},
			formatNumber(number, precision) {
				const formatted = Math.round(number / precision) * precision;
				return parseFloat(formatted.toFixed(Math.log10(1 / precision)));
			},
			onValueChanged(e) {
				this.$emit('update:value', e.value);
				this.$emit('changed', e.value);
			}
		}
	};
</script>
<style lang='scss'>
	.audio-tracker-wapi-plugin-popup--number-edit {
		@import "main/themes/generated/variables.base.scss";

		.text {
			color: var(--color);
			font-size: var(--font-size);
		}
	}
</style>
